import "./hide-on-cookie"
/**
 * @class Tracking
 * @module Ladies
 *
 * Die Tracking-Klasse bietet Funktionalitäten zum Erstellen von
 * 	Tracking-Pixeln auf der Seite, deren Bild-URL ein Skript zum Zählen
 * 	von Zugriffszahlen aufruft.
 *
 * Durch die Präsenz eines Timestamps in der URL werden diese niemals
 * 	gecached, was gewährleistet, dass wirklich jeder Aufruf gezählt
 * 	werden kann. Des Weiteren verbleibt immer nur ein Pixel im Quelltext
 * 	der Seite, da neue Pixel die alten Tags ersetzen.
 *
 * @param {jQuery|Function} $
 *
 * @member {Object} siteConfig
 * 	@property {String} trackingPath
 * 	@property {String} product
 * 	@property {String} trackingParameters
 */
export class DesktopHeader {
    visibleIntersectionRatio = 0.5
    animationDuration: number | null = null
    toggleXxlElement: typeof $
    toggleXxlHeader: typeof $
    toggleXxlImage: typeof $
    toggleXxlName: typeof $

    constructor() {
        this.toggleXxlElement = $("#touch-xxl-spot")
        this.toggleXxlHeader = $(".xxl-header")
        this.toggleXxlImage = $("#xxl-image")
        this.toggleXxlName = $(".xxl-label")
        const xxlContainer = $(".xxl-teaser-container")
        const xxlRootContainer = xxlContainer.closest(".desktop-header-banner")
        const xxlBtnC = $(".xxl-button .xclose")
        const xxlBtnO = $(".xxl-button .xopen")
        this.toggleXxlElement.on("click", this.toggleXxlBannerContainer.bind(this))

        this.toggleXxlImage.on("click", { mode: "imageClick" }, this.toggleXxlBannerContainer.bind(this))
        this.toggleXxlHeader.on("click", this.toggleXxlBannerContainer.bind(this))

        this.toggleXxlName.on("click", this.toggleXxlBannerContainer.bind(this))

        if (xxlRootContainer.hasClass("closed")) {
            xxlBtnO.css("display", "block")
            xxlBtnC.css("display", "none")
        } else {
            xxlBtnO.css("display", "none")
            xxlBtnC.css("display", "block")
        }
    }

    /**
     * Event-Ablauf zum Öffnen oder Schließen des XXL Banners auf
     * 	den Unterseiten im Seitenheader
     *
     * @private
     * @param {Event} clickEvent
     */
    toggleXxlBannerContainer(clickEvent: Event) {
        const xxlContainer = $(".xxl-teaser-container")
        const xxlMenu = $(".xxl-header")
        const xxlLabel = $(".xxl-label")
        const target = $(clickEvent.currentTarget)
        const xxlBtnC = $(".xxl-button .xclose")
        const xxlBtnO = $(".xxl-button .xopen")

        this.toggleXxlElement

        // Beim Anklicken auf das Image sollte auch ein Klick ausgelöst werden,
        // deswegen darf nix stopPropagiert werden!
        if (
            !(
                "data" in clickEvent &&
                undefined !== clickEvent.data &&
                // @ts-expect-error custom shit
                "imageClick" === clickEvent.data.mode
            )
        ) {
            clickEvent.stopPropagation()
        }

        const xxlRootContainer = xxlContainer.closest(".desktop-header-banner")

        if (xxlRootContainer.hasClass("closed")) {
            if (target.is(xxlLabel)) {
                return
            }

            $(document).trigger("xxlbanner:onopen")

            xxlMenu.addClass("active")
            xxlBtnO.css("display", "none")
            xxlBtnC.css("display", "block")
            xxlRootContainer.removeClass("closed")

            const tParent = xxlContainer.closest(".tparent[data-directly]")

            if (tParent !== null && tParent.length > 0) {
                const bannerId = $(tParent).data("bannerId")
                const bannerPlace = $(tParent).data("bannerPlace")

                if (!bannerId || !bannerPlace) {
                    return
                }

                window.Tracking.trackBannerEinblendung(bannerId, bannerPlace)
            } else {
                const tPixels = xxlContainer.find(".tpixel[data-source]")
                const pixelCount = tPixels.length
                let pixelIndex = 0

                for (; pixelIndex < pixelCount; pixelIndex++) {
                    const tPixel = $(tPixels.get(pixelIndex))

                    tPixel.prop("src", tPixel.data("source"))
                    tPixel.css("display", "block")
                }
            }
        } else {
            if (target.is(xxlMenu)) {
                return
            }

            $(document).trigger("xxlbanner:onclose")

            xxlMenu.removeClass("active")
            xxlBtnO.css("display", "block")
            xxlBtnC.css("display", "none")
            xxlRootContainer.addClass("closed")
        }

        $("html, body").animate({ scrollTop: 0 }, this.animationDuration)
    }
}

new DesktopHeader()
